import React, { useEffect, useMemo, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import styles from '@/modules/admin-access-codes/styles.less';
import ExportButton from '@/modules/admin-access-codes/components/ExportButton';
import { debounce } from '@/common/utils/index';

const Filters = ({
  search,
  status,
  resellerId,
  sortBy,
  sortOrder,
  resellerOptions = [],
  onSearchChange,
  onStatusChange,
  onResellerChange,
}) => {
  const { t } = useTranslation();
  const [searchInput, setSearchInput] = useState(search);
  const searchChangeRef = useRef(onSearchChange);

  useEffect(() => {
    searchChangeRef.current = onSearchChange;
  }, [onSearchChange]);

  const debouncedSearchChange = useMemo(
    () => debounce((value) => searchChangeRef.current(value), 300),
    []
  );

  useEffect(() => {
    setSearchInput(search);
  }, [search]);

  useEffect(() => {
    debouncedSearchChange(searchInput);
  }, [debouncedSearchChange, searchInput]);

  return (
    <div className={styles.controls}>
      <TextField
        value={searchInput}
        onChange={(event) => setSearchInput(event.target.value)}
        placeholder={t('Search by code or reseller')}
        variant="outlined"
        sx={{ minWidth: '352px' }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
      <FormControl sx={{ minWidth: '154px' }}>
        <InputLabel id="access-codes-status-label" shrink>
          {t('Status')}
        </InputLabel>
        <Select
          labelId="access-codes-status-label"
          value={status}
          label={t('Status')}
          onChange={(event) => onStatusChange(event.target.value)}
          displayEmpty
        >
          <MenuItem value="">{t('All Statuses')}</MenuItem>
          <MenuItem value="active">{t('Assigned')}</MenuItem>
          <MenuItem value="redeemed">{t('Redeemed')}</MenuItem>
          <MenuItem value="disabled">{t('Disabled')}</MenuItem>
        </Select>
      </FormControl>
      <FormControl sx={{ minWidth: '154px' }}>
        <InputLabel id="access-codes-reseller-label" shrink>
          {t('Reseller')}
        </InputLabel>
        <Select
          labelId="access-codes-reseller-label"
          value={resellerId}
          label={t('Reseller')}
          onChange={(event) => onResellerChange(event.target.value)}
          displayEmpty
        >
          <MenuItem value="">{t('All Resellers')}</MenuItem>
          {resellerOptions.map(({ id, name }) => (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ExportButton
        search={search}
        status={status}
        resellerId={resellerId}
        sortBy={sortBy}
        sortOrder={sortOrder}
      />
    </div>
  );
};

export default Filters;
